













import { Component, Vue, Prop } from "vue-property-decorator";
import { INewsItem } from "@/api/types.d.ts";
@Component
export default class ScrollPanel extends Vue {
  /** 数据 */
  @Prop()
  private list!: Array<object>;
  @Prop()
  private itemClick?: Function;
  click(item: INewsItem) {
    if (this.itemClick) {
      this.itemClick(item);
    } else {
      this.$emit("itemClick", item);
    }
  }
}
